// extracted by mini-css-extract-plugin
export default {"Backdrop":"Loader_Backdrop__Gh1Mj","Loader":"Loader_Loader__xwZ7o","loaderFadInOut":"Loader_loaderFadInOut__aEA7d"};